import React, { useState } from 'react';
import PropTypes from 'prop-types';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting.js';

import Txt from '../../../inputs/textInput.js';

let htmlToReactParser = new HtmlToReact.Parser(React);

const CenterPanelChangeEmail = React.memo(({ formik, fields, currentEmail }) => {
  return (
    <div className="center-panel pdtxs pdlxs pdbxs">
      <Container fluid as={Media} greaterThanOrEqual="tablet">
        <p className="mrbl">{htmlToReactParser.parse(xss(APP.LANGUAGE.ChangeEmail.Description))}</p>
        <div className="mrbl">
          <span>{APP.LANGUAGE.ChangeEmail.CurrentEmail}</span>
          <br />
          <span>
            <b>{currentEmail}</b>
          </span>
        </div>
      </Container>
      <Container fluid as={Media} at="mobile">
        <p className="mrbm">{htmlToReactParser.parse(xss(APP.LANGUAGE.ChangeEmail.MobileDescription))}</p>
        <div className="mrbm">
          <span>{APP.LANGUAGE.ChangeEmail.CurrentEmail}</span>
          <br />
          <span>
            <b>{currentEmail}</b>
          </span>
        </div>
      </Container>

      <form onSubmit={formik.onSubmit} className="ui form">
        {fields.map((field) => RenderField(field))}
      </form>
    </div>
  );
});

const RenderField = (field) => {
  return (
    <div key={field.id} className={`form-field ${field.className}`}>
      <label htmlFor={field.id}>{field.label}</label>
      <Txt
        autoComplete={field.autocomplete || 'false'}
        type={field.type}
        focusme={field.focusme}
        name={field.name}
        id={field.id}
        noTitle
        value={field.value}
        customOnBlur={true}
        customOnChange={true}
        onChange={field.handleChange}
        onBlur={field.handleBlur}
        notRenderPlaceholderAsTitle="true"
      >
        {field.errors && field.touched && (
          <React.Fragment>
            {field.showErrorDetail ? (
              <div className="error-label">
                <span className="error-pointy-corner" />
                <span className="error-color">{field.errors}</span>
              </div>
            ) : (
              ''
            )}
            <i className="warning big circle icon error-checkmark" onClick={() => field.setErrorDetail(true)} />
          </React.Fragment>
        )}
      </Txt>
    </div>
  );
};

CenterPanelChangeEmail.propTypes = {
  fields: PropTypes.array.isRequired,
  currentEmail: PropTypes.string.isRequired,
};

export default CenterPanelChangeEmail;
